import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from 'reactstrap'
import { useAuth } from 'providers/auth-provider'
import { fetchPendingTasks } from 'api/v2/admins/pending-tasks-api'

const TASKS = {
  sales_payment: ['Pending Payment', '/app/sales/deals/', 'pending_task=sales_payment'],
  buying_sources: ['PO Menunggu Sourcing', '/app/buying/po-sourcing', 'scope=on_sources&pending_task=buying_sources'],
  outbound_shipment: ['Shipment Belum Dikirim', '/app/outbound/deals/list', 'scope=ready_to_ship&pending_task=outbound_shipment'],
  accepted_return: ['Consignor Return Accepted', '/app/seller-outbound-returns', 'status=accepted&pending_task=accepted_return'],
  appraisal_needed: ['Appraisal Needed', '/app/inbound-journey/appraisal-needed', ''],
  confirm_buying_price: ['CF Buying Price', '/app/inbound-journey/confirm-buying-price', ''],
  appraisal_approval: ['Appraisal Approve', '/app/inbound-journey/appraisal-approval', '']
}

const PendingTaskShortcuts = ({ tasks = [] }) => {
  const { user } = useAuth()
  const history = useHistory()
  const location = useLocation()
  const [data, setData] = useState({})
  const identity = `${user?.id}:${user?.email}:${user?.role}`
  useEffect(() => {
    let active = true
    setData({})
    fetchPendingTasks(identity).then((result) => { if (active) setData(result) }).catch(() => {})
    const refresh = (event) => { if (event.detail?.identity === identity) setData(event.detail.data) }
    window.addEventListener('pending-tasks-refreshed', refresh)
    return () => { active = false; window.removeEventListener('pending-tasks-refreshed', refresh) }
  }, [identity, location.pathname])
  const visible = tasks.filter((key) => data.counts?.[key] !== undefined)
  if (!visible.length) return null
  return <div className='d-flex flex-wrap mb-3' style={{ gap: 8 }}>
    {visible.map((key) => {
      const [label, path, search] = TASKS[key]
      const personal = key === 'appraisal_needed' ? data.appraisal_scope === 'own' : ['sales_payment', 'buying_sources'].includes(key) && data.scope !== 'all'
      const taskSearch = key === 'appraisal_needed' && personal ? 'pending_task=appraisal_needed' : search
      const taskLabel = key === 'appraisal_needed' && personal ? 'Appraisal Filled' : label
      return <Button key={key} color='warning' size='sm' onClick={() => {
        history.push(`${path}?page=1&${taskSearch}`)
        window.scrollTo(0, 0)
      }}>{taskLabel}{personal ? ' (Saya)' : ''} ({data.counts[key]})</Button>
    })}
    {new URLSearchParams(location.search).has('pending_task') && <Button color='secondary' outline size='sm' onClick={() => history.push(location.pathname)}>Lihat Semua / Hapus Filter Tugas</Button>}
  </div>
}

export default PendingTaskShortcuts
